
import { WeglotService } from '../internationalize/weglot.service';
import { NewsletterService } from '../newsletter/newsletter.service';
import { registerComponents } from './register-components'

interface TbwServices {
  newsletterService: NewsletterService;
  weglotService: WeglotService;
}

declare global {
  interface Window {
    tbwServices: TbwServices;
  }
}

const init = async () => {
  const newsletterService = new NewsletterService();
  const weglotService = new WeglotService("wg_cff40a3545b2e1dbc1bd021a254abde41");

  window.tbwServices = {
    newsletterService,
    weglotService
  };
  // console.log("here")

  registerComponents()
  return true
}

init()